export class CasinoMessageData {
    type: string | undefined;
    data: MessageData | undefined;
}
export class MessageData {
    key: string | undefined;
    value: string | undefined;
}

export class SportsWindowEvent {}
export class MiniGamesWidgetExpandedEvent implements SportsWindowEvent {}
export class MiniGamesWidgetCollapsedEvent implements SportsWindowEvent {}
export class MiniGamesWidgetPostSessionKeyEvent implements SportsWindowEvent {}
